import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Button, Card, CardHeader, Spinner } from '@os/ui';
import { z } from 'zod';
import { api } from '@/services/http';

/** Always register addon routes; this gate is host chrome when the addon is off. */
export function AddonGate({ addonId, children }: { addonId: string; children: ReactNode }) {
  const nav = useNavigate();
  const addons = useQuery({
    queryKey: ['addons'],
    queryFn: () => api('/addons', { schema: z.object({ data: z.array(z.object({ id: z.string(), enabled: z.boolean() })) }) }),
    staleTime: 30_000,
  });
  if (addons.isLoading) return <div style={{ display: 'grid', placeItems: 'center', flex: 1 }}><Spinner /></div>;
  const on = addons.data?.data.find((a) => a.id === addonId)?.enabled ?? false;
  if (!on) {
    return (
      <div className="tl-content">
        <Card padded>
          <CardHeader title="This add-on is turned off" />
          <p className="meta">Enable it under App → Add-ons to use this feature.</p>
          <div style={{ marginTop: 12 }}><Button onClick={() => nav('/settings/addons')}>Open Add-ons</Button></div>
        </Card>
      </div>
    );
  }
  return children;
}
